import { AttentionType, RiskSeverity } from '@kainos/shared';
import type { AttentionItem } from '@kainos/validation';
import { DEMO_TENANT_ID } from './session.js';
import { daysAgo, hoursAgo } from './time.js';

/**
 * The five exceptions the design surfaces, already in priority order.
 *
 * In production this list is produced by `buildAttentionItems` in
 * `@kainos/domain` from live issues, risks, decisions and activities.
 */
export const DEMO_ATTENTION: AttentionItem[] = [
  {
    id: 'iss_tablero',
    tenantId: DEMO_TENANT_ID,
    type: AttentionType.BLOCKER,
    projectId: 'prj_montajeelectrico',
    projectName: 'Montaje Eléctrico Subestación Sur',
    activityId: 'act_2',
    title: 'Instalación tablero eléctrico',
    reason: 'Falta de sensores de temperatura por parte del proveedor.',
    impact: 'Puede retrasar el hito Puesta en marcha ~3 días y afecta 1 actividad dependiente.',
    ownerId: 'usr_carlos',
    ownerName: 'Carlos Muñoz',
    severity: RiskSeverity.CRITICAL,
    since: daysAgo(2),
    suggestedAction: 'Contactar proveedor',
    aiDetected: false,
    proposed: false,
  },
  {
    id: 'act_1:delay',
    tenantId: DEMO_TENANT_ID,
    type: AttentionType.DELAY,
    projectId: 'prj_plantanorte',
    projectName: 'Implementación Planta Norte',
    activityId: 'act_1',
    title: 'Validación planos eléctricos',
    reason: 'Sin registro de avance desde el inicio de la revisión.',
    impact: 'Bloquea el inicio de nuevas actividades de Construcción.',
    ownerId: 'usr_daniela',
    ownerName: 'Daniela Rojas',
    severity: RiskSeverity.HIGH,
    since: daysAgo(1),
    suggestedAction: 'Revisar con Daniela',
    aiDetected: false,
    proposed: false,
  },
  {
    id: 'rsk_bodega',
    tenantId: DEMO_TENANT_ID,
    type: AttentionType.RISK,
    projectId: 'prj_bodegacentral',
    projectName: 'Ampliación Bodega Central',
    activityId: 'act_7',
    title: 'Posible atraso en entrega de bodega',
    reason: 'Patrón histórico de retrasos del proveedor de materiales de cierre.',
    impact: 'El hito Entrega final podría moverse ~5 días.',
    ownerId: 'usr_camila',
    ownerName: 'Camila Araya',
    severity: RiskSeverity.HIGH,
    since: hoursAgo(6),
    suggestedAction: 'Confirmar riesgo',
    aiDetected: true,
    proposed: true,
  },
  {
    id: 'dec_proveedor',
    tenantId: DEMO_TENANT_ID,
    type: AttentionType.DECISION,
    projectId: 'prj_montajeelectrico',
    projectName: 'Montaje Eléctrico Subestación Sur',
    activityId: 'act_2',
    title: 'Aprobar cambio de proveedor de sensores',
    reason: 'Proveedor actual no puede garantizar entrega esta semana.',
    impact: 'Desbloquea Instalación tablero eléctrico y su dependiente.',
    ownerId: 'usr_felipe',
    ownerName: 'Felipe Soto',
    severity: RiskSeverity.HIGH,
    since: daysAgo(1),
    suggestedAction: 'Revisar y decidir',
    aiDetected: false,
    proposed: false,
  },
  {
    id: 'act_5:stale',
    tenantId: DEMO_TENANT_ID,
    type: AttentionType.STALE,
    projectId: 'prj_plantanorte',
    projectName: 'Implementación Planta Norte',
    activityId: 'act_5',
    title: 'Capacitación operadores',
    reason: 'Sin reportes de avance registrados.',
    impact: 'Riesgo de pérdida de trazabilidad antes de Puesta en marcha.',
    ownerId: 'usr_daniela',
    ownerName: 'Daniela Rojas',
    severity: RiskSeverity.LOW,
    since: daysAgo(8),
    suggestedAction: 'Solicitar actualización',
    aiDetected: false,
    proposed: false,
  },
];

/** Extra risk detail shown in the project Riesgos tab. */
export const DEMO_RISK_DETAIL: Record<string, { probability: string; severity: string }> = {
  rsk_bodega: { probability: 'Media', severity: 'Alta' },
};
